
import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import ContactForm from '../components/ContactForm';

const Contacto = () => {
  return (
    <div className="container">
      <div className="sede-header">
        <h1>Contacto</h1>
        <p>Estamos aquí para responder tus preguntas y brindarte toda la información que necesites sobre nuestros servicios.</p>
      </div>

      <section className="contact-section" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px', marginBottom: '50px' }}>
        <div>
          <h2>Información de contacto</h2>
          <p>Puedes comunicarte con nosotros de lunes a viernes de 8 a 16 hs a través de cualquiera de los siguientes medios:</p>

          <div className="contact-info" style={{ marginTop: '20px' }}>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaEnvelope className="contact-icon" />
              <a href="mailto:tulugar1@hotmail.com">tulugar1@hotmail.com</a>
            </div>

            <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>Sede Temperley</h3>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaMapMarkerAlt className="contact-icon" />
              <span>A. Gallardo 646, Provincia de Buenos Aires</span>
            </div>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaPhone className="contact-icon" />
              <span>1165651675</span>
            </div>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaWhatsapp className="contact-icon" />
              <a href="https://wa.me/5491165651675" target="_blank" rel="noopener noreferrer">WhatsApp: 1165651675</a>
            </div>

            <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>Sede Glew</h3>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaMapMarkerAlt className="contact-icon" />
              <span>RP210 Nº 22548, Provincia de Buenos Aires</span>
            </div>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaPhone className="contact-icon" />
              <span>1165661677</span>
            </div>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaWhatsapp className="contact-icon" />
              <a href="https://wa.me/5491165661677" target="_blank" rel="noopener noreferrer">WhatsApp: 1165661677</a>
            </div>

            <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>Síguenos en redes sociales</h3>
            <div style={{ display: 'flex', gap: '15px' }}>
              <a href="https://www.facebook.com/MiLugarTemperley" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaFacebook />
              </a>
              <a href="https://www.instagram.com/cet.milugar/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <h2 className="section-title">Nuestras Sedes</h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          <div className="map-container">
            <h3>Sede Temperley</h3>
            <p>A. Gallardo 646, Provincia de Buenos Aires</p>
            <div style={{ marginTop: '15px', height: '300px' }}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3277.632979084912!2d-58.4!3d-34.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQ4JzAwLjAiUyA1OMKwMjQnMDAuMCJX!5e0!3m2!1ses!2sar!4v1634567890123!5m2!1ses!2sar" 
                width="100%" 
                height="100%" 
                style={{ border: 0, borderRadius: '8px' }} 
                allowFullScreen="" 
                loading="lazy"
                title="Mapa Sede Temperley"
              ></iframe>
            </div>
          </div>

          <div className="map-container">
            <h3>Sede Glew</h3>
            <p>RP210 Nº 22548, Provincia de Buenos Aires</p>
            <div style={{ marginTop: '15px', height: '300px' }}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3278.1!2d-58.4!3d-34.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDU0JzAwLjAiUyA1OMKwMjQnMDAuMCJX!5e0!3m2!1ses!2sar!4v1634567890123!5m2!1ses!2sar" 
                width="100%" 
                height="100%" 
                style={{ border: 0, borderRadius: '8px' }} 
                allowFullScreen="" 
                loading="lazy"
                title="Mapa Sede Glew"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Float Button */}
      <a href="https://wa.me/5491165651675" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Contacto;
